import React, {FC} from 'react'
import {Tooltip, Whisper} from 'rsuite'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../helpers'

interface ActionButtonProps {
  tooltip: string;
  to?: string;
  iconPath: string;
  iconClass: string;
  className: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ActionsButton: FC<ActionButtonProps> = ({
                                                tooltip,
                                                to,
                                                iconPath,
                                                iconClass,
                                                className,
                                                onClick,
                                                disabled = false
                                              }) => (
  <Whisper placement="top" controlId="control-id-click" trigger="hover" speaker={<Tooltip>{tooltip}</Tooltip>}>
    {to ? (
      <Link className={className} to={to}>
        <KTSVG path={iconPath} className={iconClass} />
      </Link>
    ) : (
      <button className={className} onClick={onClick} disabled={disabled}>
        <KTSVG path={iconPath} className={iconClass} />
      </button>
    )}
  </Whisper>
)

export {ActionsButton}